import { useAuthContext } from '@/contexts/AuthContext';

// Re-export the context hook as useAuth for backward compatibility
export const useAuth = () => {
  return useAuthContext();
};
